exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".modal-open .modal{top:0;bottom:0;-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;backface-visibility:hidden}.modal-open .modal.fade .modal-dialog{height:100%;margin:0 auto;position:absolute;top:0;left:0;right:0;bottom:0;overflow-y:auto;overflow-x:none;-webkit-overflow-scrolling:touch;transform:none;max-width:none;pointer-events:all;padding:10px}.no-scroll,.no-scroll body{overflow:hidden}.modal-content{max-width:500px;margin:0 auto}.modal-footer{padding-bottom:1.5rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./resources/assets/js/vendor/bootstrap-modal-ios/bootstrap-modal-ios.css
// module id = zAmy
// module chunks = 0